import React from "react";

import { Box, Typography } from "@mui/material";

import { AssistantActionButton, AssistantMutedText } from "../../styles";
import {
  AssistantWalkthroughFeatureActions,
  AssistantWalkthroughFeatureCard,
  StyledAssistantWalkthroughFeatureListBoxDisplay,
} from "./styles";
import { IAssistantWalkthroughFeatureListProps } from "./types";
import { getAssistantWalkthroughFeatureOffers } from "./utils";

const AssistantWalkthroughFeatureList: React.FC<IAssistantWalkthroughFeatureListProps> =
  ({ walkthroughFeatures, pendingIds, onDismiss }) => {
    const offers = getAssistantWalkthroughFeatureOffers(
      walkthroughFeatures,
      pendingIds
    );

    if (!offers.length) return null;

    return (
      <Box component="section" aria-label="New features to learn">
        <Typography variant="h5" component="h3">
          Something new to learn
        </Typography>
        <AssistantMutedText variant="subtitle7" mb={4}>
          I can walk you through the new features available to you.
        </AssistantMutedText>
        <StyledAssistantWalkthroughFeatureListBoxDisplay>
          {offers.map((offer) => (
            <AssistantWalkthroughFeatureCard key={offer.id}>
              <Typography variant="h8" component="h4">
                {offer.title}
              </Typography>
              <AssistantMutedText variant="subtitle7">
                {offer.description}
              </AssistantMutedText>
              <AssistantWalkthroughFeatureActions>
                <AssistantActionButton
                  variant="outlined"
                  fullWidth={false}
                  round
                  disabled={offer.pending}
                  onClick={() => onDismiss(offer.id)}
                  aria-label={`Dismiss ${offer.title}`}
                >
                  Dismiss
                </AssistantActionButton>
                <AssistantActionButton
                  variant="contained"
                  color="secondary"
                  fullWidth={false}
                  round
                  href={offer.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  disabled={offer.pending || !offer.href}
                  aria-label={`Teach me: ${offer.title} (opens in a new tab)`}
                >
                  Teach me
                </AssistantActionButton>
              </AssistantWalkthroughFeatureActions>
            </AssistantWalkthroughFeatureCard>
          ))}
        </StyledAssistantWalkthroughFeatureListBoxDisplay>
      </Box>
    );
  };

export default AssistantWalkthroughFeatureList;
